import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  dialogTitle: {
    color: theme.palette.blue_300.main
  }
}))
